import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import './panel.css';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js';
import './nlp/tabler.css';

function fitText(o) {
    o = $(o);
    if (!o.length) return;
    var max = 3;
    while (o[0].offsetWidth < o[0].scrollWidth && max-- > 0) {
        console.log('title', parseInt(o.css('fontSize')), o[0].offsetWidth, o[0].scrollWidth);
        o.css({ fontSize: parseInt(o.css('fontSize')) - 2 });
    }
}

var tab;


var selectedModels = null;
var nselected = 0;

function DatasetModelRuns(prop) {

    var global = window.GlobalVars;

    function tabSelect(selectData) {
        var mruns = Object.keys(selectData);
        selectedModels = mruns;
        nselected = mruns.length;
        if (nselected) {
            if( nselected == 1 ) {
                $('#actionButton').html('View Run').show();
            }
            else {
                $('#actionButton').html('Compare Runs (' + nselected + ')').show();
            }
        }
        else {
        	$('#actionButton').hide();
        }
        console.log('selectedModels', selectedModels, nselected);
    }

    function compareModels() {
        console.log('selectedModels', selectedModels);
        if (selectedModels.length > 1) {
            let baselineModel = null;
            let opts = [...selectedModels];
            opts.unshift({label:'&nbsp;',value:''})
            frm.myAlert('Select Baseline Model', '<div class="tag-wrap"><div class="run-model-choose"></div></div>', 'Select Model', function (ev) {
                let pidx = selectedModels.indexOf(baselineModel); 
                if( pidx == -1 ){
                    ev.preventDefault();
                    ev.stopPropagation();
                    frm.removeInlineErrors()
                    return frm.inlineError( inp, "Select the baseline model")
                } 
                let slist = [...selectedModels];
                // let slist = selectedModels;
                let first = slist.splice(pidx,1);
                slist.push( first[0] );
                viewRuns(slist)
            }, 'Cancel');
            $('.modal-body').find('.tag-wrap').css({height: 200});
            var inp = frm.dropDown($('.run-model-choose'), opts, '', { allowNew: false, placeholder: 'Select Baseline Model', width: '100%' }, function (v) {
                frm.removeInlineErrors();
                baselineModel = v;
            });
        }
        else
            viewRuns(selectedModels)
    }

    function fix(s) { return (s).toString().replace(/[^a-z0-9 \.@_\-\:\/]/ig, '').toLowerCase().replace(/ +/g, ' ').trim() }
    // function fix(s) { return (s).toString().replace(/[^a-z0-9 \.@_\-]/ig, '').toLowerCase().replace(/ +/g, ' ').trim() }

    function viewRuns( list ) {
        var configKey = 'di-'+global.currentDatasetId;
        var tmpcfg = JSON.parse(atob(global.config[configKey]))
        var ftr = tmpcfg[7].filter( f => f.key != 'Model Run' && f.key != '_all');
        // var ftr = [];
        for( var l of list ) {
            ftr.unshift({
                "key": "Model Run",
                "value": fix(l),
                "id": l,
                "type": 0,
                "fid": 1,
                "value2": ""
            })
        }
        // if( projFilter ) ftr.push( projFilter );
        console.log( 'viewRuns', list, JSON.stringify(ftr) )
        tmpcfg[7] = ftr;
        global.config[configKey] = btoa(JSON.stringify(tmpcfg))
        window.saveSession( () => {
            window.goPage('datasetItems')
        })
    }

    useEffect(function (a) {
        $('#topbuttons').html('');

        var dashAction = $('<Button id="actionButton" type="submit" class="ml-2 mt-2 btn btn-primary" style="display:none">Action <i class="fa fa-caret-down"></i></Button>')
        dashAction.on('click', compareModels);
        $('#topbuttons').append(dashAction);
        // if( window.hasPriv( 'admin', 'c_admin') )
        // {
        //     var addBut = $('<Button id="addDataset" variant="primary" type="submit" class="mt-2 btn btn-primary">Create New Dataset</Button>')
        //     addBut.on('click', () => {
        //         window.GlobalVars.currentDatasetId = null;
        //         window.GlobalVars.currentDataset = null;
        //         window.saveSession( function(){
        //             window.goPage('datasetSetup');
        //         });
        //     })
        //     $('#topbuttons').append(addBut);
        // }
        window.post('find_model_runs', { datasetId: global.currentDatasetId }, function (res) {
            console.log('DATASETS', res.data);
            var modelRuns = res.data.records;
            var annotations = [];
            var results = $('#results').html('');
            console.log('modelRuns', modelRuns);
            if (!modelRuns.length) {
                $('.alert').remove();
                var empty = $('<div role="alert" class="fade alert alert-danger show">').html('No model runs found');
                $('#topbuttons').prepend(empty);
                return;
            }
            var desc = {
                title: 'Model Runs',
                columns: {
                    modelRunId: 'ID',
                    items: 'Items',
                    modelName: 'model',
                    progress: 'Progress',
                    note: 'User Note',
                    createdBy: 'Created By',
                },
                filter: true,
                search: true,
                sort: true,
                initialSort: 'created',
                initialSortDir: -1,
                pageSize: 10,
                noFilter: {
                    modified: 1,
                },
                selectMode: true,
                selectId: 'modelRunId',
                noSort: null,
                centerCol: ['items', 'progress'],
                format: tabler.formatString,
                forceType: {
                    numProjects: 1,
                    items: 1,
                    created: 1,
                },
                colWidth: {
                    name: 30,
                },
                clickCol: 'modelRunId',
                formatCol: {
                    exportId: function (s) { return '<i class="fa fa-download"></i> ' + s },
                    progress: function (v) { return (100 * v).toFixed(0) + '%' },
                    created: tabler.formatTimeAgoSec,
                }
                // clickCol: ['stateLabel','source'],
            }
            desc.columns.created = 'Created';
            console.log('DESC', desc)
            tab = tabler.table($('#documentlist'), desc, 'modelRuns' + global.currentDatasetId);
            modelRuns.forEach(a => {
                console.log('addproj', a)
                a.progress = (a.processed + a.errors) / a.items;
                tab.addRow(a, function (col, row) {
                    // console.log('tabler clickkkkk', col, row, row[col])
                    viewRuns( [row[col]] )
                })
            });
            tab.onSelect(tabSelect)
            tab.draw();
        });
    });

    return (
        <div fluid="md p-0" className="maincontent">
            <div id="topbuttons"></div>

            <Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
            </Table>
            <div id="results" className="project-browse">
            </div>
        </div>

    )
}

export default DatasetModelRuns
